import './spektrixMembership.html.twig';
import './spektrixMembership.css';

export default function() {
  const el = document.querySelector('.spektrix-memberships');
  if (!el) {
    return;
  }
  const urlList = document.getElementsByTagName('script');
  let i = urlList.length;
  let wcFlag = false;
  let swcFlag = false;
  while (i--) {
    if (urlList[i].src === 'https://webcomponents.spektrix.com/stable/webcomponents-loader.js') {
      wcFlag = true;
      break;
    }
    if (urlList[i].src === 'https://webcomponents.spektrix.com/stable/spektrix-component-loader.js') {
      swcFlag = true;
      break;
    }
  }
  if (!wcFlag) {
    const script = document.createElement('script');
    script.setAttribute('src', 'https://webcomponents.spektrix.com/stable/webcomponents-loader.js');
    document.head.appendChild(script);
  }
  if (!swcFlag) {
    const script = document.createElement('script');
    script.setAttribute('src', 'https://webcomponents.spektrix.com/stable/spektrix-component-loader.js');
    script.setAttribute('data-components', 'spektrix-donate,spektrix-memberships');
    document.head.appendChild(script);
  }
}
